import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import VisibilityIcon from "@material-ui/icons/Visibility";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { bookingApi } from "functions/apis";

import { formatDateTime, token } from "functions/Helper";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const useStyles = makeStyles(styles);

export default function SubmittedList() {
  const source = useRef(new AbortController());

  useEffect(() => {
    return () => source.current.abort();
  }, []);
  const [data, setData] = React.useState([]);
  const [pages, setPages] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [filter, setFilter] = React.useState({
    searchString: null,
    status: 1,
    sort: 15
  });
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    setLoading(true);
    bookingApi
      .get("/AgentBookingTransfers", {
        signal: source.current.signal,
        params: {
          filter: filter,
          pagination: pagination
        }
      })
      .then(data => {
        setData(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  {(token["booking.agent_booking_transfers.read"] ===
                    "allowed" ||
                    token.is_admin === "True") && (
                    <Link
                      to={"/admin/AgentBookingTransfer/Detail/" + record.id}
                    >
                      <Button color="info" className="like">
                        <VisibilityIcon /> View
                      </Button>
                    </Link>
                  )}

                  {(token["booking.agent_booking_cancellations.approve"] ===
                    "allowed" ||
                    token.is_admin === "True") && (
                    <Link
                      to={"/admin/AgentBookingTransfer/Approve/" + record.id}
                    >
                      <Button color="info" className="like">
                        <AssignmentTurnedInIcon /> Approve
                      </Button>
                    </Link>
                  )}
                  {(token["booking.agent_booking_cancellations.reject"] ===
                    "allowed" ||
                    token.is_admin === "True") && (
                    <Link
                      to={"/admin/AgentBookingTransfer/Reject/" + record.id}
                    >
                      <Button color="danger" className="remove">
                        <AssignmentLateIcon /> Reject
                      </Button>
                    </Link>
                  )}
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
        setLoading(false);
      })
      .catch(error => console.log(error));
  }, [pagination, filter]);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              SUBMITTED BOOKING TRANSFER
            </h4>
          </CardHeader>
          <CardBody>
            <GridItem xs={3}>
              <CustomInput
                labelText="Search"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: handleSearchStringChanged,
                  value: filter.searchString === null ? "" : filter.searchString
                }}
              />
            </GridItem>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                {
                  Header: "No",
                  accessor: "no"
                },
                {
                  id: "agent",
                  Header: "Agent",
                  accessor: d => d.agent.name
                },
                {
                  id: "bookingNo",
                  Header: "Booking No",
                  accessor: d => d.booking.no
                },
                {
                  id: "submittedAt",
                  Header: "Submitted At",
                  accessor: d => formatDateTime(new Date(d.submittedAt + "Z"))
                },
                {
                  Header: "Submitted By",
                  accessor: "submittedBy"
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
